export default {
    blue: {
        base: '#006eaf',
        light: '#007cf9',
        dark: '#00578b',
    },
    white: '#fff',
    black: '#2c2a29',
    grey: {
        11: '#53565a',
        7: '#97999b',
        1: '#EDEDED',
    },
};
